import React, {useEffect, useRef, useState} from 'react';
import classnames from "classnames";
import * as StatusTypes from "../../constants/contents/EntryStatusTypes";
import WindowEventHelper from "../../lib/WindowEventHelper";
import {isDescendant} from "../../utils/DomHelper";
import * as ContentsVisibility from "../../constants/ContentsVisibility"

function EntryStatusButtonItem(props) {
  const { selected, status, onChange } = props;
  return (
    <label className={classnames('lab_set', {on: selected})}>
      <input type="radio" className="inp_set" value={status} onClick={() => onChange(status)}/>
      <span className="txt_set txt_ellip">{StatusTypes.toLabel(status)}</span>
    </label>
  );
}

export default function EntryStatusChangeButton(props) {

  const { className, item, disabled, types, onChange } = props;
  const [open, setOpen] = useState(false);
  const rootEl = useRef(null);

  useEffect(() => {
    WindowEventHelper.add("click", handleWindowClick);

    return function cleanup() {
      WindowEventHelper.remove("click", handleWindowClick);
    }
  });

  function handleWindowClick(e) {
    let target = e.target;

    if (!isDescendant(rootEl.current, target)) {
      setOpen(false);
    }
  }

  function handleChange(status) {
    onChange(status);
    setOpen(false);
  }

  const status = item.visibility;
  const isPrivateContents = ContentsVisibility.isPrivate(item.visibility, item.categoryVisibility);

  const statusLabel = isPrivateContents ? StatusTypes.PRIVATE_LABEL : StatusTypes.toLabel(status);

  return (
    <div ref={rootEl} className={classnames(`opt_set ${className}`, {
      'opt_open': open,
      'change_on': item.processing,
      'off': disabled
    })} onMouseLeave={() => setOpen(false)}>
      <button type="button" className="btn_opt" disabled={disabled} onClick={() => setOpen(true)}>
        <span className="txt_ellip">{statusLabel}</span>
        <span className="ico_blog" />
      </button>

      <div className="layer_opt">
        {types.map(type =>
          <EntryStatusButtonItem
            key={type}
            status={type}
            selected={status === type}
            onChange={handleChange}
          />
        )}

        <button type="button" className="btn_close">
          <span className="ico_blog" />
        </button>
      </div>

      <span className="txt_change">변경중<span className="ico_blog ico_change"/></span>

    </div>
  );
}
